// src/components/Panels.jsx

import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import UserList from './UserList';
import ParticipantsList from './ParticipantsList';

const DiscussionPanels = ({
  // États d'affichage
  showFilePanel, setShowFilePanel,
  showCardPanel, setShowCardPanel,
showUtilsPanelBottom, setShowUtilsPanelBottom,

  showUserList, setShowUserList,
  showParticipantsList, setShowParticipantsList,
  showSearch, setShowSearch,


  // Refs fichiers
  imageInputRef,
  videoInputRef,
  audioInputRef,
  pdfInputRef,
  onCameraClick,
  onImageClick,

  // Handlers fichiers
  handleIconClick,
  handleFileChange,
  requestCameraPermission,

  // Cartes
  setShowBirthdayCard,
  setShowLoveCard,
  setShowAmbianceCard,
  setShowNewYearCard,

  // Utils panel
  isPublic, isCreator, isMobile,
  participants, discussion,
  currentUserId, discussionId,
  selectedDiscussion,
  onEdit, setEditModal,
  handleLeaveDiscussionPrivate,
  handleDeleteDiscussion,
  handleInviteClick,
  handleInviteUser,
  handleOpenWhiteboard,
  setShowAgenda,
  startVideoCall,
  prompt,
showAutoDeleteModal,
setShowAutoDeleteModal,
autoDeleteAfter,
setAutoDeleteAfter,
}) => {
  const { t } = useTranslation();
//const localImageRef = useRef(null);
const localCameraRef = useRef(null);


  // ── Styles ──────────────────────────────────────────────
  const btnStyle = {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', gap: '5px',
    background: 'rgba(128,128,128,0.1)',
    border: '1px solid rgba(128,128,128,0.15)',
    borderRadius: '10px', padding: '10px 4px 8px',
    cursor: 'pointer', minHeight: '60px', color: 'var(--input-color)',
  };
const btnStyleBottom = {
  display: 'flex',
  flex: '1',
  flexShrink: '0', 
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '2px',
  background: 'none',
  border: 'none',
  borderRadius: '10px',
  padding: '2px 2px 2px',
  cursor: 'pointer',
opacity: '0.7',

  color: 'var(--input-color)',
};

  const btnWideStyle = {
    display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px',
    background: 'rgba(128,128,128,0.1)',
    border: '1px solid rgba(128,128,128,0.15)',
    borderRadius: '10px', padding: '10px 14px',
    cursor: 'pointer', minHeight: '48px', color: 'var(--input-color)',
  };
  const labelStyle = {
    fontSize: '10px', color: 'var(--input-color)',
    opacity: 0.7, textAlign: 'center', lineHeight: 1.2,
  };
  const labelWideStyle = {
    fontSize: '12px', color: 'var(--input-color)',
    opacity: 0.8, display: 'flex', alignItems: 'center', gap: '6px',
  };
  const badgeStyle = {
    fontSize: '9px', background: 'rgba(55,138,221,0.15)',
    color: '#378ADD', borderRadius: '4px', padding: '1px 5px', fontWeight: '500',
  };
  const utilsBtnStyle = {
    background: 'none', border: '1px solid var(--input-color)',
    borderRadius: '10px', padding: '10px', cursor: 'pointer',
    color: 'var(--input-color)', fontSize: '14px',
    display: 'flex', alignItems: 'center', gap: '8px',
  };
  const iconBlueStyle = { fontSize: '22px', color: '#007bff' };
const iconOrangeStyle = { fontSize: '22px', color: '#F59E0B' };
  const iconRedStyle  = { fontSize: '22px', color: 'red' };
  const iconGrayStyle = { fontSize: '18px', color: '#666' };
  const closeBtnStyle = {
    position: 'absolute', top: '8px', right: '8px',
    width: '28px', height: '28px', borderRadius: '50%',
    background: 'rgba(128,128,128,0.15)', border: 'none',
    cursor: 'pointer', display: 'flex', alignItems: 'center',
    justifyContent: 'center', color: 'var(--input-color)',
  };
const [isDragging, setIsDragging] = useState(false);
const [dragStartY, setDragStartY] = useState(0);
const [dragCurrentY, setDragCurrentY] = useState(0);

useEffect(() => {
  if (!isDragging) return;

  const handleMouseMove = (e) => {
    setDragCurrentY(e.clientY);
  };

  const handleTouchMove = (e) => {
    setDragCurrentY(e.touches[0].clientY);
  };

  const handleEndDrag = () => {
    // Si l'utilisateur a glissé vers le bas de plus de 50px, ferme la modal
    if (dragCurrentY - dragStartY > 50) {
      setShowUserList(false);
      setShowParticipantsList(false);
    }
    setIsDragging(false);
  };

  window.addEventListener('mousemove', handleMouseMove);
  window.addEventListener('mouseup', handleEndDrag);
  window.addEventListener('touchmove', handleTouchMove);
  window.addEventListener('touchend', handleEndDrag);



  return () => {
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleEndDrag);
    window.removeEventListener('touchmove', handleTouchMove);
    window.removeEventListener('touchend', handleEndDrag);
  };
}, [isDragging, dragStartY, dragCurrentY]);

const handleUtilsScroll = (e) => {
  const el = e.target;
  const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
  document.getElementById('utilsFade').classList.toggle('hidden', atEnd);
};

const getTTLLabel = (value) => {
  if (!value) return t('duree.jamais');
  if (value === 365) return t('duree.an', { count: 1 });
  return t('duree.jour', { count: value });
};


  return (
    <>
      {/* ── Input image — hors panneau pour éviter le blocage WebView ── */}
	 
      

      {/* ════════════════════════════════════════════
          PANNEAU FICHIERS (slide bottom)
      ════════════════════════════════════════════ */}
      <div style={{
        position: 'fixed',
        bottom: showFilePanel ? '0' : '-180px',
        left: '0', right: '0',
        background: 'var(--input-bg)',
        borderRadius: '16px 16px 0 0',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
        padding: '14px 16px 20px',
        zIndex: 3500, transition: 'bottom 0.3s ease',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: 'var(--input-color)', opacity: 0.6 }}>
            {t('file_panel.title')}
          </span>
          <button onClick={() => setShowFilePanel(false)} aria-label={t('file_panel.close')} style={closeBtnStyle}>
            <i className="ti ti-x" style={{ fontSize: '14px' }} aria-hidden="true" />
          </button>
        </div>

        {/* Grille 4 boutons */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '8px', marginBottom: '8px' }}>
          <button onClick={onCameraClick} style={btnStyle}>
            	<i className="ti ti-camera" style={{ fontSize: '22px' }} aria-hidden="true" />

            <span style={labelStyle}>{t('file_panel.image')}</span>
          </button>

          <button onClick={() => handleIconClick('video')} style={btnStyle}>
            <i className="ti ti-video" style={{ fontSize: '22px' }} aria-hidden="true" />
            <span style={labelStyle}>{t('file_panel.video')}</span>
            <input type="file" accept="video/*" ref={videoInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
          </button>
          <button onClick={() => handleIconClick('audio-existing')} style={btnStyle}>
            <i className="ti ti-headphones" style={{ fontSize: '22px' }} aria-hidden="true" />
            <span style={labelStyle}>{t('file_panel.audio')}</span>
            <input type="file" accept="audio/*" ref={audioInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
          </button>
          <button onClick={() => handleIconClick('pdf')} style={btnStyle}>
            <i className="ti ti-file-text" style={{ fontSize: '22px' }} aria-hidden="true" />
            <span style={labelStyle}>{t('file_panel.document')}</span>
            <input type="file"
              accept="application/pdf, application/vnd.oasis.opendocument.text, text/plain, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.oasis.opendocument.presentation, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.oasis.opendocument.spreadsheet"
              ref={pdfInputRef} style={{ display: 'none' }} onChange={handleFileChange}
            />
          </button>
        </div>

        {/* Ligne 2 boutons larges */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '8px' }}>
          <button onClick={() => { setShowCardPanel(!showCardPanel); setShowFilePanel(false); }} style={btnWideStyle}>
            <i className="ti ti-cards" style={{ fontSize: '22px' }} aria-hidden="true" />
            <span style={labelWideStyle}>{t('file_panel.card')}</span>
          </button>

          {isMobile && (
            <button onClick={() => handleIconClick('video-record')} style={btnWideStyle}>
              <i className="ti ti-broadcast" style={{ fontSize: '22px' }} aria-hidden="true" />
              <span style={labelWideStyle}>
    {t('file_panel.record')}
    <span style={badgeStyle}>{t('file_panel.live')}</span>
  </span>
            </button>
          )}
        </div>
      </div>

      {/* ════════════════════════════════════════════
          PANNEAU CARTES (slide left)
      ════════════════════════════════════════════ */}
      <div style={{
        position: 'fixed',
        left: showCardPanel ? '0' : '-220px',
        top: '50%', transform: 'translateY(-50%)',
        width: '200px', background: 'var(--input-bg)',
        borderRadius: '0 16px 16px 0',
        boxShadow: '4px 0 20px rgba(0,0,0,0.3)',
        padding: '20px 12px', zIndex: 3000,
        transition: 'left 0.3s ease',
        display: 'flex', flexDirection: 'column', gap: '12px',
      }}>
        <button onClick={() => setShowCardPanel(false)} aria-label="Fermer" style={closeBtnStyle}>
          <i className="ti ti-x" style={{ fontSize: '14px' }} aria-hidden="true" />
        </button>
        <p style={{ fontSize: '0.8rem', opacity: 0.6, margin: '0 0 8px 0', textAlign: 'center', color: 'var(--input-color)' }}>
          {t('cards.panel_title')}
        </p>
        {[
          { emoji: '🎂', label: t('cards.anniversaire_label'), action: () => { setShowBirthdayCard(true); setShowCardPanel(false); setTimeout(() => setShowBirthdayCard(true), 300); } },
          { emoji: '💝', label: t('cards.love_label'),         action: () => { setShowLoveCard(true);     setShowCardPanel(false); } },
          { emoji: '🎴', label: t('cards.ambiance_label'),     action: () => { setShowAmbianceCard(true); setShowCardPanel(false); } },
          { emoji: '🎆', label: t('cards.voeux_label'),        action: () => { setShowNewYearCard(true);  setShowCardPanel(false); } },
        ].map((card) => (
          <button key={card.label} onClick={card.action} style={utilsBtnStyle}>
            {card.emoji} {card.label}
          </button>
        ))}
      </div>

      {/* ════════════════════════════════════════════
          PANNEAU UTILS (bottom)
      ════════════════════════════════════════════ */}

      <div
className="utilsPanel"
  style={{
    position: 'fixed', 
  bottom: '5px',
    left: 0,
    right: 0,
    background: 'var(--bg-color)',
    padding: '0 40px 10px 20px',
    zIndex: 3000, 
    display: showUtilsPanelBottom ? 'flex' : 'none',
    flexDirection: 'row',
alignItems: 'flex-start',
    gap: '10px',
    justifyContent: 'space-between',
    transition: 'bottom 0.3s ease',
display: showUtilsPanelBottom ? 'block' : 'none'
  }}

>
{/* Conteneur pour le scroll horizontal */}
    <div className="utilsPanel-scroll-wrap"
      style={{
        width: '100%',
        overflowX: 'hidden',
        paddingRight: '10px',
      }}
    >
      <div id="utilsScroll" 
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          justifyContent: 'flex-start',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          paddingBottom: '10px',
        }}
	onScroll={handleUtilsScroll}
      >
  {/* les boutons */}

        

        <button className="utilsPanel-btn" onClick={() => { setShowParticipantsList(!showParticipantsList); setShowUserList(false); }} style={btnStyleBottom}>
          <i className="ti ti-users" style={iconBlueStyle} aria-hidden="true" />
         <span style={labelStyle}> {!isPublic ? t('utils.participants') : t('diffusion.abonnes')}</span>
          </button>


        {isMobile && isCreator && !isPublic && participants.length > 1 && (
          <button className="utilsPanel-btn" onClick={handleInviteClick} style={btnStyleBottom}>
            <i className="ti ti-user-plus" style={iconBlueStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('utils.inviter')}</span>
          </button>
        )}

        {isPublic && isCreator && (
          <button className="utilsPanel-btn" onClick={() => { if (!onEdit) { setEditModal(selectedDiscussion); } else { onEdit(selectedDiscussion); } }} style={btnStyleBottom}>
            <i className="ti ti-pencil" style={iconBlueStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('diffusion.editer')}</span>
          </button>
        )}

        

        {participants.length > 1 && !isPublic && (
          <button className="utilsPanel-btn" onClick={async () => { const { confirm } = prompt; const ok = await confirm(t('discussion.alertvideo')); if (ok) startVideoCall(discussion._id); }} style={btnStyleBottom}>
            <i className="ti ti-video" style={iconBlueStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('discussion.videocall')}</span>
          </button>
        )}

        {!isPublic && (
          <button className="utilsPanel-btn" onClick={() => setShowAgenda(true)} style={btnStyleBottom}>
            <i className="ti ti-calendar" style={iconBlueStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('utils.agendas')}</span>
          </button>
        )}

        {!isPublic && (
          <button className="utilsPanel-btn" onClick={() => handleOpenWhiteboard()} style={btnStyleBottom}>
            <i className="ti ti-writing" style={iconBlueStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('utils.tableaux')}</span>
          </button>
        )}
{!isPublic && (
  <button className="utilsPanel-btn"
    onClick={() => {
  setShowSearch(true);
  setShowUtilsPanelBottom(false);
  
}}
    style={btnStyleBottom}
  >
    <i className="ti ti-search" style={iconBlueStyle} aria-hidden="true" />
     <span style={labelStyle}>{t('utils.search')}</span>
  </button>
)}

{isCreator && isPublic && (
          <button className="utilsPanel-btn" onClick={() => handleDeleteDiscussion(discussion._id)} style={btnStyleBottom}>
            <i className="ti ti-trash" style={iconRedStyle} aria-hidden="true" />
            <span style={labelStyle}>{!isPublic ? t('utils.supprimer') : t('diffusion.supprimer')}
          </span></button>
        )}

{!isPublic && (
          <button className="utilsPanel-btn" onClick={() => handleLeaveDiscussionPrivate(discussion._id)} style={btnStyleBottom}>
            <i className="ti ti-logout" style={iconRedStyle} aria-hidden="true" />
            <span style={labelStyle}>{t('utils.quitter')}</span>
          </button>
        )}


        {((showUserList && participants.length > 1) || showParticipantsList) && (
  <div
    onClick={() => { setShowUserList(false); setShowParticipantsList(false); }}
    style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: 'var(--input-bg)',
        borderRadius: '16px 16px 0 0',
        width: '100%',
        maxHeight: '70vh',
        overflowY: 'auto',
        padding: '16px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
        transform: isDragging ? `translateY(${dragCurrentY - dragStartY}px)` : 'translateY(0)',
        transition: isDragging ? 'none' : 'transform 0.3s ease',
      }}
    >
      {/* Handle bar */}
      <div
        style={{
          width: '40px',
          height: '4px',
          background: 'rgba(128,128,128,0.3)',
          borderRadius: '2px',
          margin: '0 auto 16px',
          cursor: 'grab',
        }}
        onClick={() => {
          setShowUserList(false);
          setShowParticipantsList(false);
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
          setIsDragging(true);
          setDragStartY(e.clientY);
          setDragCurrentY(e.clientY);
        }}
        onTouchStart={(e) => {
          e.stopPropagation();
          setIsDragging(true);
          setDragStartY(e.touches[0].clientY);
          setDragCurrentY(e.touches[0].clientY);
        }}
      />

      

      {/* Titre */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
      }}>
	{participants.length > 1 && (
        <span style={{ fontWeight: '600', fontSize: '15px', color: 'var(--text-color)' }}>
          {showUserList
            ? t('utils.inviter')
            : (!isPublic ? t('utils.participants') : t('diffusion.abonnes'))
          }
        </span>
	)}
        <button
          onClick={() => { setShowUserList(false); setShowParticipantsList(false); }}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <i className="ti ti-x" style={{ fontSize: '18px', color: 'var(--text-color)' }} aria-hidden="true" />
        </button>
      </div>

      {/* Contenu */}
      {showUserList && participants.length > 1 && (
        <UserList
          key={Date.now()}
          discussionId={discussionId}
          onInvite={handleInviteUser}
          creatorId={discussion.creator}
          currentUserId={currentUserId}
          prompt={prompt}
          onClose={() => setShowUserList(false)}
        />
      )}
      {showParticipantsList && (
        <ParticipantsList
          discussionId={discussionId}
          creatorId={discussion.creator}
          currentUserId={currentUserId}
          isPublic={isPublic}
          prompt={prompt}
        />
      )}
    </div>
  </div>


)}
     </div>
<div className="utilsPanel-fade" id="utilsFade" />

  </div> 

  </div>
    </>
  );
};

export default DiscussionPanels;